import React, { useEffect, useState } from "react";
import { FaYoutube } from "react-icons/fa";
import SlideInOutAnimation from "./SlideInOutAnimation";

const YouTubeFeed = () => {
  const [videos, setVideos] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("POPULAR");

  const videoCategories = ["POPULAR", "LATEST"];
  const popularVideos = React.useMemo(
    () => [
      {
        title:
          "How To Create a Solar System Animation | HTML | CSS | JavaScript | ASMR Coding",
        thumbnail: "https://i.ytimg.com/vi/qCp9mipNKuo/hqdefault.jpg",
        link: "https://www.youtube.com/watch?v=qCp9mipNKuo",
      },
      {
        title: "Running Car Animation | HTML & CSS",
        thumbnail: "https://i.ytimg.com/vi/Gio0USmDJWY/hqdefault.jpg",
        link: "https://www.youtube.com/watch?v=Gio0USmDJWY",
      },
      {
        title:
          "How to Create Doughnut & Line Charts in Angular | Angular Charts & Graphs with Chart.js",
        thumbnail: "https://i.ytimg.com/vi/shwcMRVUg-k/hqdefault.jpg",
        link: "https://www.youtube.com/watch?v=shwcMRVUg-k",
      },
      {
        title:
          "How to Send Emails in Java Spring Boot Using Gmail - Step-by-Step Guide!",
        thumbnail: "https://i.ytimg.com/vi/W1nRtR9Z17M/hqdefault.jpg",
        link: "https://www.youtube.com/watch?v=W1nRtR9Z17M",
      },
      {
        title: "🌐 HTMX – Simplifying Modern Web Development 🚀",
        thumbnail: "https://i.ytimg.com/vi/iggDqbCU5iI/hqdefault.jpg",
        link: "https://www.youtube.com/watch?v=iggDqbCU5iI",
      },
      {
        title: "macOS Dock Clone - HTML, CSS, JavaScript | CogniSolver",
        thumbnail: "https://i.ytimg.com/vi/y0NF80XDRyc/hqdefault.jpg",
        link: "https://www.youtube.com/watch?v=y0NF80XDRyc",
      },
    ],
    []
  );

  const fetchVideos = async () => {
    const feedUrl =
      "https://www.youtube.com/feeds/videos.xml?channel_id=UCqzk01BOuZwZSgJ4zoufMTw";
    const rssToJson = `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent(
      feedUrl
    )}`;
    const res = await fetch(rssToJson);
    const data = await res.json();
    setVideos(data.items.slice(0, 6)); // only show latest 6
  };

  useEffect(() => {
    if (selectedCategory === "POPULAR") {
      setVideos(popularVideos);
    } else {
      // Call async function properly inside useEffect
      (async () => {
        await fetchVideos();
      })();
    }
  }, [selectedCategory, popularVideos]);

  return (
    <section className="px-6 py-16 text-center">
      <SlideInOutAnimation>
        <h2 className="text-4xl font-bold mb-10">
          MY <span className="text-yellow-500">YOUTUBE</span>
        </h2>
      </SlideInOutAnimation>
      <div className="flex justify-center mb-4">
        {videoCategories.map((category) => (
          <div
            key={category}
            className={`mx-2 cursor-pointer text-xl font-semibold hover:text-white transition-colors duration-300 border-b-2 hover:border-yellow-500 ${
              selectedCategory === category
                ? "text-white border-yellow-500"
                : "text-gray-400 border-transparent"
            }`}
            onClick={() => setSelectedCategory(category)}
          >
            {category}
          </div>
        ))}
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mt-4 md:px-20">
        {videos.map((video) => (
          <SlideInOutAnimation key={video.guid} className="bg-gray-800 p-2">
            <div className="relative h-36 flex flex-col items-center justify-center">
              <a
                href={video.link}
                target="_blank"
                rel="noopener noreferrer"
                className="absolute p-2 rounded-full bg-[#fff] z-10 hover:scale-125 transition-transform duration-300"
              >
                <FaYoutube className="text-red-500 text-xl" />
              </a>
              <img
                src={video.thumbnail}
                alt={video.title}
                className="w-44 object-cover"
              />
            </div>
            <p className="text-[12px] font-bold">{video.title}</p>
          </SlideInOutAnimation>
        ))}
      </div>
    </section>
  );
};

export default YouTubeFeed;
